import "./portfolio.css";
import JobManager from "../../assets/JobManager.png";
const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Works</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio-container">
        <article className="portfolio-item">
          <div className="portfolio-item-image">
            <img src={JobManager} alt="" />
          </div>
          <h3>This is a portfolio item title</h3>
          <div className="portfolio-cta">
            <a
              href="https://github.com"
              className="btn"
              title="gitHub"
              target="_blank"
              rel="noreferrer noopener"
            >
              GitHub
            </a>
            <a
              href="https://job-manager-backend.onrender.com"
              className="btn btn-primary"
              title="gitHub"
              target="_blank"
              rel="noreferrer noopener"
            >
              Live Demo
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};
export default Portfolio;
